<script lang="ts" setup>
  import mjapiblockbutton from "./mjapiblockbutton.vue";
  import mjapiblocktext from "./mjapiblocktext.vue";
  import mjapiblockimage from "./mjapiblockimage.vue";
  import { h as createElement } from "vue";

  const props = defineProps({
    block: {
      type: String,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    columnIndex: {
      type: Number,
      required: true,
    },
    sectionIndex: {
      type: Number,
      required: true,
    },
    blockIndex: {
      type: Number,
      required: true,
    },
    product: {
      type: Object,
      required: true,
    },
  });

  const emits = defineEmits(["open-settings"]);

  const onOpenSettings = (type: string) => {
    emits("open-settings", type);
  };

  const getComponent = () => {
    switch (props.block) {
      case "button":
        return mjapiblockbutton;
      case "image":
        return mjapiblockimage;
      default:
        return mjapiblocktext;
    }
  };

  const render = () => {
    return createElement(getComponent(), {
      block: props.product,
      item: props.item,
      index: props.index,
      columnIndex: props.columnIndex,
      sectionIndex: props.sectionIndex,
      blockIndex: props.blockIndex,
      "data-testid": "mj-product-" + props.block,
      onOpenSettings: onOpenSettings,
      name: props.block,
      key: props.block,
    });
  };
</script>

<template>
  <render />
</template>
